import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  FormControl,
  MenuItem,
  Typography,
} from "@mui/material";
import { Field } from "formik";

import { FormikDimensionedNumberInput } from "common/components/FormikDimensionedNumberInput";
import { JobType } from "protos/atk/job_type";
import { jobTypeToLocaleString } from "common/utils/enumTranslations";
import { RigDetailsFormState } from "../FormState";
import { rtcJobsApi } from "common/state/rtcJobsApi";
import { Select } from "formik-mui";
import { typedPath } from "typed-path";
import { useSelf } from "portal/state/store";
import { useTranslation } from "react-i18next";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import React from "react";

const S = typedPath<RigDetailsFormState>();

export const JobsSubform: React.FC<{ readOnly: boolean }> = ({ readOnly }) => {
  const { t } = useTranslation();
  const { measurementSystem } = useSelf();
  // todo: add a query string to this so users can search -- or some other way to paginate.
  const { data } =
    rtcJobsApi.endpoints.listStartupChecklistDefinitions.useQuery();

  return (
    <Accordion className="w-full">
      <AccordionSummary expandIcon={<ExpandMoreIcon />}>
        {t("views.autotractor.rigDetails.configuration.jobs.sectionHeader")}
      </AccordionSummary>
      <AccordionDetails>
        <FormControl fullWidth className="col-span-full">
          <Typography>
            {t(
              "views.autotractor.rigDetails.configuration.jobs.thisConfigCompatibleWith"
            )}
          </Typography>
          <Field
            name={S.jobSettings.jobType.$path}
            component={Select}
            displayEmpty
            disabled={readOnly}
          >
            <MenuItem value={JobType.GROUND_PREP}>
              {jobTypeToLocaleString(t, JobType.GROUND_PREP)}
            </MenuItem>
            <MenuItem value={JobType.LASER_WEED}>
              {jobTypeToLocaleString(t, JobType.LASER_WEED)}
            </MenuItem>
          </Field>
        </FormControl>
        <FormControl>
          <Typography>
            {t(
              "views.autotractor.rigDetails.configuration.jobs.safetyChecklist"
            )}
          </Typography>
          <Field
            name={S.jobSettings.checklistDefinitionId.$path}
            component={Select}
            displayEmpty
            disabled={readOnly}
          >
            {data?.checklistDefinitions.map((cl) => (
              <MenuItem key={cl.id} value={cl.id} className="flex flex-col">
                <div className="font-bold mr-auto">{cl.content?.name}</div>
                <div className="text-sm mr-auto flex-wrap">
                  {cl.content?.description}
                </div>
              </MenuItem>
            ))}
          </Field>
        </FormControl>
        <FormControl>
          <FormikDimensionedNumberInput
            label={t(
              "views.autotractor.rigDetails.configuration.jobs.checklistTimeout"
            )}
            name={S.jobSettings.checklistTimeoutS.$path}
            validate={true}
            dimensionedNumberInputProps={{
              storedUnit: "s",
              displayUnits: {
                metric: "h",
                imperial: "h",
              },
              localSystem: measurementSystem,
              disabled: readOnly,
            }}
            className="w-full self-end"
          />
        </FormControl>
      </AccordionDetails>
    </Accordion>
  );
};
